import script from "./UserPreferencesDefaultGroupsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPreferencesDefaultGroupsTab.vue?vue&type=script&setup=true&lang=js"

import "./UserPreferencesDefaultGroupsTab.vue?vue&type=style&index=0&id=4cabe637&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cabe637"]])

export default __exports__